import React from 'react';

const MetaFacebook = ({ url, title, description, image, t }) => {
  return (
    <>
      <meta property="og:image" content={image.replace('.webp', '.jpeg')} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title || t('ace-text-design-ac')} />
      <meta
        property="og:description"
        content={description || t('ace-text-design-ac')}
      />
      <meta property="og:site_name" content={t('ace-text-design-ac')} />
      <meta property="fb:app_id" content="117289276958719" />
      <meta property="og:type" content="article" />
    </>
  );
};

export default MetaFacebook;
